import { spacing } from 'studio/helpers';

export default theme => ({
  root: {
    maxWidth: 1100,
    minWidth: 600,
    '& .MuiTypography-h6': {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3)
    }
  },
  form: {
    marginTop: theme.spacing(3)
  },
  keyHelp: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: -spacing(theme, 1)
  },
  actions: {
    marginTop: theme.spacing(5),
    '& .MuiButton-root': {
      marginRight: theme.spacing(1)
    }
  }
});
